// @ts-nocheck
import { useEffect, useRef, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';
import { dismissToast, getToasts, subscribeToasts } from '../../utils/toast/toastStore';

const AUTO_DISMISS_MS = 6_000;

/** Global toast stack (centered under the app shell header). Use {@link pushToast} from non-React code. */
export function Toaster() {
  const toasts = useSyncExternalStore(subscribeToasts, getToasts, getToasts);
  const dismissTimersRef = useRef(new Map());

  useEffect(() => {
    const activeIds = new Set(toasts.map((t) => t.id));

    for (const t of toasts) {
      if (dismissTimersRef.current.has(t.id)) continue;
      const timerId = window.setTimeout(() => {
        dismissTimersRef.current.delete(t.id);
        dismissToast(t.id);
      }, AUTO_DISMISS_MS);
      dismissTimersRef.current.set(t.id, timerId);
    }

    for (const [id, timerId] of dismissTimersRef.current.entries()) {
      if (!activeIds.has(id)) {
        window.clearTimeout(timerId);
        dismissTimersRef.current.delete(id);
      }
    }
  }, [toasts]);

  useEffect(() => {
    return () => {
      for (const timerId of dismissTimersRef.current.values()) {
        window.clearTimeout(timerId);
      }
      dismissTimersRef.current.clear();
    };
  }, []);

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="toast-stack" role="region" aria-live="polite" aria-label="Notifications">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.tone}`} role="status">
          <span className="toast__message">{t.message}</span>
          <button
            type="button"
            className="toast__dismiss"
            aria-label="Dismiss notification"
            onClick={() => dismissToast(t.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>,
    document.body
  );
}
